import L from 'leaflet';

export const iconUser = new L.Icon({
	iconUrl: require('../../icons/Current Location.png'),
	iconRetinaUrl: require('../../icons/x2/Current Location.png'),
	iconSize: new L.Point(24, 24),
	iconAnchor: new L.Point(12, 12),
	className: 'leaflet-user-icon',
});
export const iconNumbers: L.Icon[] = [];
for (let ndx = 0; ndx < 20; ndx++) {
	iconNumbers[ndx] = new L.Icon({
		iconUrl: require(
			`../../icons/NumberedIcons/NumberedIcon-${ndx + 1}.png`,
		),
		iconRetinaUrl: require(
			`../../icons/NumberedIcons/NumberedIcon-${ndx + 1}.png`,
		),
		iconSize: new L.Point(24, 24),
		className: 'leaflet-div-icon',
	});
}

export const divIconNumbers: L.DivIcon[] = [];
for (let ndx = 0; ndx < 50; ndx++) {
	divIconNumbers[ndx] = new L.DivIcon({
		html: `<div style="background-color: #000; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 12px; font-weight: bold;">${ndx + 1}</div>`,
		iconSize: new L.Point(24, 24),
		className: 'leaflet-div-icon',
		iconAnchor: new L.Point(12, 12),
	});
}

export const iconPOI = new L.Icon({
	iconUrl: require('../../icons/Generic Dot.png'),
	iconRetinaUrl: require('../../icons/x2/Generic Dot.png'),
	iconSize: new L.Point(16, 16),
	iconAnchor: new L.Point(8, 8),
	className: 'leaflet-div-icon',
});
export const iconPOI_Highlighted = new L.Icon({
	iconUrl: require('../../icons/Highlighted Dot.png'),
	iconRetinaUrl: require('../../icons/x2/Highlighted Dot.png'),
	iconSize: new L.Point(16, 16),
	iconAnchor: new L.Point(8, 8),
	className: 'leaflet-div-icon',
});
export const iconStart = new L.Icon({
	iconUrl: require('../../icons/Start.png'),
	iconRetinaUrl: require('../../icons/x2/Start.png'),
	iconSize: new L.Point(24, 24),
	iconAnchor: new L.Point(12, 12),
	className: 'leaflet-div-icon',
});
export const iconEnd = new L.Icon({
	iconUrl: require('../../icons/End.png'),
	iconRetinaUrl: require('../../icons/x2/End.png'),
	iconSize: new L.Point(24, 24),
	iconAnchor: new L.Point(12, 12),
	className: 'leaflet-div-icon',
});
